

/**
 * @name AddMessageController
 * @description Controller for notes
 * @param {type} Messages Description
 * @param {type} _ Description
 * @param {type} $rootScope Angular rootScope service
 * @param {service} Session The session service
 * @param {service} $log Angular log service
 * @param {service} Participants The Participants service
 * @param {library} moment The moment service
 */
function AddMessageController(
  Messages,
  _,
  $rootScope,
  Session,
  $log,
  Participants,
  moment
) {
  let vm = this;

  vm.$onInit = function() {
    vm.data = Messages;
    vm.session = Session;

    // Public methods
    vm.create = create;

    // Defaults
    vm.message = {
      content: null,
      private: false
    };
    vm.privateOption = _.isUndefined(vm.privateOption) ? true : false;
  };

  /**
   * @name get
   * @description Function to add a message to a conversation.
   * @param {number} message The new message to create
   */
  function create(message) {
    message.cid = vm.conversationId;
    // Check to ensure message is not null or spaces
    if (message.content !== null && message.content.replace(/\s/g, '').length) {
      Messages.create(message).then(function(newMessage) {
        let appointmentId;
        let projectId;
        $rootScope.$broadcast('merge-activity', vm.conversationId,
        appointmentId, projectId);
        vm.message.content = null;
        vm.message.private = false;
        let conversationId = newMessage.conversation;
        // let collectorId = Session.collector.id;
        Participants.get(conversationId, appointmentId)
        .then(function(participants) {
          let loggedInParticipant = _.find(participants, function(participant) {
            if (participant.collector === Session.collector.id) {
              return true;
            }
          });
          if (loggedInParticipant) {
            let formattedParticipant = {
              id: loggedInParticipant.id,
              last_read_date: moment.utc().format('YYYY-MM-DDTHH:mm:ss')
            };
            Participants.update(formattedParticipant)
            .then(function(updatedParticipant) {
              $rootScope.$broadcast('created-new-message',
              updatedParticipant.id);
            });
          }
        });
      });
    }
  }
}

angular
  .module('inkfinder')
  .controller('AddMessageController', AddMessageController);



// WEBPACK FOOTER //
// ./components/messages/add/add-message.controller.js